<template>
    <div>
      <div class="container-scroller">
        <div class="container-fluid page-body-wrapper full-page-wrapper">
          <div class="content-wrapper d-flex align-items-center auth">
            <div class="row flex-grow">
              <div class="col-lg-4 mx-auto">
                <div class="auth-form-light text-center p-5">
                  <h1>BAMBA254</h1>
                  <div class="brand-logo justify-content-center">
                    <img src="/assets/img/admin.png" />
                  </div>
                  <h2>Admin Login</h2>

                  <div class="mt-4">
                    <div id="g_id_onload"
                      data-client_id="36667530562-nl7v78qd78rqi1qflaqsl2k3bb970714.apps.googleusercontent.com"
                      data-callback="handleCredentialResponse">
                    </div>
                    <div class="google-btn" id="googleLogin">
                      <div class="google-icon-wrapper">
                        <img class="google-icon" src="/assets/img/google.png" />
                      </div>
                      <p class="btn-text"><b>Sign in with Google</b></p>
                    </div>
                  </div>

                </div>
              </div>
            </div>
            <!-- content-wrapper ends -->
          </div>
          <!-- page-body-wrapper ends -->
        </div>
      </div>
    </div>
  </template>

  <script>
  import { nextTick } from "vue";

  export default {
    name: "Login",
    data(){
        return {
            message:{},
            view:false,
        }
    },
    created() {
      this.getIp();
      this.getTime();
      localStorage.clear();
    },
    mounted() {
      const token = localStorage.getItem("token");

      if (token) {
        this.$router.push({ name: "kmtc" });
      } else {
        this.initGoogleLogin();
      }
    },
    methods: {
      async getIp() {
        try {
          const response = await this.axios.get(`https://api.ipify.org/?format=json`);
          this.message.ip_address = response.data.ip;
        } catch (error) {
          console.error("Error fetching IP:", error);
        }
      },

      getTime() {
        const today = new Date();
        this.message.date_time = today.toISOString();
      },

      initGoogleLogin() {
        window.handleCredentialResponse = this.handleCredentialResponse;

        nextTick(() => {
          if (window.google && document.getElementById("googleLogin")) {
            google.accounts.id.initialize({
              client_id: "36667530562-nl7v78qd78rqi1qflaqsl2k3bb970714.apps.googleusercontent.com",
              callback: window.handleCredentialResponse,
              auto_select: false,
            });

            google.accounts.id.renderButton(
              document.getElementById("googleLogin"),
              { theme: "outline", size: "large" }
            );

            google.accounts.id.prompt(); // Show One-Tap login prompt
          } else {
            console.error("Google Login script not loaded or element not found.");
          }
        });
      },

      async handleCredentialResponse(response) {
  console.log("Google Credential Response:", response);

  if (!response.credential) {
    console.error("No credential received from Google.");
    return;
  }

  try {
    const backendResponse = await this.axios.post(`/api/auth/google-login`, {
      token: response.credential,
    });

    console.log("Backend Response:", backendResponse.data);

    if (backendResponse.data.status) {
        localStorage.setItem("token", backendResponse.data.token);
        localStorage.setItem("user", JSON.stringify(backendResponse.data.user));
this.$nextTick(() => {
  console.log("Redirecting now...");
  this.$router.push({ name: "kmtc" });
});


    } else {
      console.error("Login failed:", backendResponse.data.message);
      this.$swal({
        title: "Authentication Failure",
        text: backendResponse.data.message,
        icon: "warning",
      });
    }
  } catch (error) {
    console.error("Google login API error:", error);
    this.$toast.open({
      message: "Google login failed!",
      type: "error",
      position: "top",
    });
  }
}

    },
  };
  </script>
